import { useNavigate } from "react-router-dom";
import DSBox from "../../../system-design/DSBox";
import DSCard from "../../../system-design/DSCard";
import DSCardContent from "../../../system-design/DSCardContent";
import DSSectionHeading from "../../../system-design/DSSectionHeading";
import { sectionCardSx } from "../../../system-design/sectionCardSx";
import DSTypography from "../../../system-design/DSTypography";
import DSChip from "../../../system-design/DSChip";
import DSButton from "../../../system-design/DSButton";
import { useClockContentProfiles } from "../../../ContentProfiles/hooks/useContentProfiles";

/**
 * Which content profiles hold this clock, and when each last pushed to it.
 * Hidden when there are none.
 */
const DeviceContentProfilesCard = ({ deviceId }: { deviceId: string }) => {
  const navigate = useNavigate();
  const { data: profiles } = useClockContentProfiles(deviceId);

  if (!profiles?.length) return null;

  return (
    <DSCard sx={[sectionCardSx, { mb: 2 }]}>
      <DSSectionHeading>Content profiles</DSSectionHeading>
      <DSCardContent>
        {profiles.map((profile) => (
          <DSBox
            key={profile.id}
            sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
          >
            <DSButton
              size="small"
              onClick={() => navigate(`/admin/profiles/${profile.id}`)}
            >
              {profile.name}
            </DSButton>
            {profile.orderName && (
              <DSChip size="small" label={`Order ${profile.orderName}`} />
            )}
            <DSTypography variant="caption" color="text.secondary">
              {profile.pushedAt
                ? `Pushed ${new Date(profile.pushedAt).toLocaleString()}`
                : "Not pushed to this clock yet"}
            </DSTypography>
          </DSBox>
        ))}
      </DSCardContent>
    </DSCard>
  );
};

export default DeviceContentProfilesCard;
